import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CsvImportPage } from '@/areas/settings/Settings/CsvImportPage/CsvImportPage';
import { canViewOtherOrganizationSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/csv-integration')({
    staticData: {
        access: { permissions: canViewOtherOrganizationSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CsvImportPage />;
}
